import React from "react";

const ProgressBar = ({ progress, total }) => {
	const progressPercentage = (progress / total) * 100;

	return (
		<div className="w-full">
			<div className="progress-bar-container bg-white bg-opacity-85 shadow-lg border rounded-full p-2 w-full">
				<div className="progress-bar bg-gray-300 w-full rounded-lg h-2">
					<div
						className="progress-bar-fill bg-black h-full rounded-lg"
						style={{ width: `${progressPercentage}%` }}
					></div>
				</div>
			</div>

			<p className="text-right text-sm mt-1 text-white">
				{progress}/{total} questions repondues
			</p>
		</div>
	);
};

export default ProgressBar;
